<template>
	<div>
		<div
            class="container mx-auto px-4 lg:px-0"
            v-if="contest"
        >
			<div>
				<h1>{{ contest.title }} Voting Page</h1>
				<div style="font-size: 20px;">Please choose a score for each column with five being the maximum. Make sure to score all {{ totalEntries }} entries.</div>
				<div style="margin-bottom: 12px;">
					Note that it is possible (and faster) to tab through the drop-downs and use the number keys on your keyboard to make your choices. If tabbing through the entries, be sure not to alter the totals by accident.
				</div>
			</div>
            <div
                v-if="$store.state.user"
            >
                Submitting as {{ $store.state.user.email }}
            </div>
			<div
                v-else
            >
                Please create an account to submit a form by clicking Login > Register in the top right.
			</div>
            <div
                class="flex "
            >
                <div
                    class="w-1/2"
                >
                    <div

                    >
                        <div
                            v-for="(categoryEntries, categoryTitle) in categories"
                        >
                            <div
                                v-if="categoryEntries.length"
                            >
                                <h3>{{ categoryTitle }}*</h3>
                                <table>
                                    <thead style="font-size: 12px;">
                                    <th style="padding-right: 8px;">Title</th>
                                    <th style="padding-right: 8px;">Image</th>
                                    <th style="padding-right: 8px;">Artistic<br/>Merit</th>
                                    <th style="padding-right: 8px;">Subject<br/>Matter</th>
                                    <th style="padding-right: 8px;">Composition</th>
                                    <th style="padding-right: 8px;">Originality</th>
                                    <th style="padding-right: 8px;">Technical<br/>Quality</th>
                                    <th style="padding-right: 8px;">Total</th>
                                    </thead>
                                    <tr
                                        :class="{'current': currentEntry && currentEntry.id === entry.id }"
                                        v-for="entry in categoryEntries"
                                    >
                                        <td
                                            style="width: 200px; font-size: 12px; line-height: 14px; padding: 4px 0px;"
                                        >
                                            <a
                                                @mouseover="setCurrentEntry(entry)"
                                                :href="`/contests/${this.contest.slug}/entries/${entry.id}`"
                                                target="_blank"
                                            >
                                                {{ entry.item_name }}
                                            </a>
                                        </td>
                                        <td
                                            style="width: 20px; padding: 4px;"
                                        >
                                            <img
                                                class="cursor-pointer"
                                                @mouseover="setCurrentEntry(entry)"
                                                :src="entry.main_image.thumb"
                                            />
                                        </td>
                                        <td style="min-width: 70px; padding-right: 8px; padding-top: 4px; padding-bottom: 4px;">
                                            <select
                                                :style="`width: 100%; border: 1px solid ${borderColor(entry.error)}`"
                                                :name="`artistic_merit_id_${entry.id}`" :id="`artistic_merit_id_${entry.id}`"
                                                :key="`artistic_merit_id_${entry.id}`"
                                                v-model="entry.artistic_merit"
                                            >
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </td>
                                        <td style="min-width: 70px; padding-right: 8px; padding-top: 4px; padding-bottom: 4px;">
                                            <select
                                                :style="`width: 100%; border: 1px solid ${borderColor(entry.error)}`"
                                                :name="`subject_matter_id_${entry.id}`" :id="`subject_matter_id_${entry.id}`"
                                                v-model="entry.subject_matter"
                                            >
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </td>
                                        <td style="min-width: 70px; padding-right: 8px; padding-top: 4px; padding-bottom: 4px;">
                                            <select
                                                :style="`width: 100%; border: 1px solid ${borderColor(entry.error)}`"
                                                :name="`composition_id_${entry.id}`" :id="`composition_id_${entry.id}`"
                                                v-model="entry.composition"
                                            >
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </td>
                                        <td style="min-width: 70px; padding-right: 8px; padding-top: 4px; padding-bottom: 4px;">
                                            <select
                                                :style="`width: 100%; border: 1px solid ${borderColor(entry.error)}`"
                                                :name="`originality_id_${entry.id}`" :id="`originality_id_${entry.id}`"
                                                v-model="entry.originality"
                                            >
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </td>
                                        <td style="min-width: 70px; padding-right: 8px; padding-top: 4px; padding-bottom: 4px;">
                                            <select
                                                :style="`width: 100%; border: 1px solid ${borderColor(entry.error)}`"
                                                :name="`quality_id_${entry.id}`" :id="`quality_id_${entry.id}`"
                                                v-model="entry.quality"
                                            >
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </td>
                                        <td>
                                            {{
                                                (entry.artistic_merit ? Number(entry.artistic_merit) : 0) +
                                                (entry.subject_matter ? Number(entry.subject_matter) : 0) +
                                                (entry.composition ? Number(entry.composition) : 0) +
                                                (entry.originality ? Number(entry.originality) : 0) +
                                                (entry.quality ? Number(entry.quality) : 0)
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

                <div
                    class="w-1/2"
                >
                    <div
                        id="sticking"
                    >
                        <a
                            :href="currentEntry && currentEntry.main_image ? currentEntry.main_image.full : ''"
                            target="_blank"
                        >
                            <img
                                style="max-width: 90%; max-height: 100vh;"
                                :src="currentEntry && currentEntry.main_image ? currentEntry.main_image.large: ''"
                            />
                        </a>
                    </div>
                </div>
            </div>

			<div style="display: flex; margin-top: 16px;">
				<div
					v-on:click="saveForm"
					style="margin-right: 8px; padding: 8px 16px; border: 1px solid gray; border-radius: 5px; cursor: pointer; display: inline-block; margin-bottom: 12px;"
				>
					Save
				</div>
				<div
					v-on:click="submitForm"
					style="padding: 8px 16px; border: 1px solid gray; border-radius: 5px; cursor: pointer; display: inline-block; margin-bottom: 12px;"
				>
					Submit
				</div>
			</div>

			<div
				v-if="displayThanks"
			>
				{{ displayThanks }}
			</div>
			<div style="display: none">
				{{ myComputedValue }}
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	name: 'judging-form',
	data() {
		return {
			refreshKey: 0,
			isAnotherValue: '',
			categories: {},
			categoriesJSON: '',
			contest: null,
			totalEntries: 0,
			displayThanks: '',
            currentImage: '',
            currentScroll: 0,
            currentEntry: '',
		}
	},
	mounted() {
		// this.autofill();
		this.getFormData();
        window.addEventListener('scroll', this.stickToTop)
	},
	methods: {
        setCurrentEntry(entry) {
            this.currentEntry = entry;
        },
        stickToTop() {
            let el = document.getElementById('sticking');
            this.currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (this.currentScroll > 300) {
                el.style.top = this.currentScroll + 'px';
                el.style.position = 'absolute';
            } else {
                el.style.top = '0px';
                el.style.position = 'relative';
            }
        },
		getFormData() {
			const laravelAuthToken = localStorage.getItem('laravelAuthToken');
			let authHeaders = {
				headers: {"Authorization" : `Bearer ${laravelAuthToken}`}
			};
			axios.get(`/api/contests/${this.$route.params.contest}/judging-form`, authHeaders).then((res) => {
				const data = res.data.serverData;
				this.categories = data.categories;
				this.categoriesJSON = JSON.stringify(data.categories);
				this.contest = data.contest;
				this.totalEntries = data.totalEntries;
			})
		},
		saveForm() {
			const data = {
				categories: this.categories,
			}
			const laravelAuthToken = localStorage.getItem('laravelAuthToken');
			let authHeaders = {
				headers: {"Authorization" : `Bearer ${laravelAuthToken}`}
			};
			axios.post(`/api/contests/${this.$route.params.contest}/judging-form/save`, data, authHeaders).then((res) => {
				this.displayThanks = 'Your progress has been saved.'
			}).catch((res) => {
				this.displayThanks = res.response.data.message
			}).finally((res) => {
				this.clearMessage();
			})
		},
		submitForm() {
			let isValid = true;
			Object.values(this.categories).map((categoryEntries) => {
				categoryEntries.map((entry) => {
					if (entry.artistic_merit === undefined ||
					entry.subject_matter === undefined ||
					entry.composition === undefined ||
					entry.originality === undefined ||
					entry.quality === undefined)
					{
						entry.error = true;
						isValid = false;
					} else {
						entry.error = false;
					}
				})
			})
			if (isValid === false) {
				this.forceRefresh();
				return;
			}
			const data = {
				categories: this.categories,
			}
			const laravelAuthToken = localStorage.getItem('laravelAuthToken');
			let authHeaders = {
				headers: {"Authorization" : `Bearer ${laravelAuthToken}`}
			};
			axios.post(`/api/contests/${this.$route.params.contest}/judging-form/submit`, data, authHeaders).then((res) => {
				this.displayThanks = 'Thank you. Your form has been submitted.';
			}).catch((res) => {
				this.displayThanks = res.response.data.message
			}).finally((res) => {
				this.clearMessage();
			})
		},
		clearMessage() {
			setTimeout(() => {
				this.displayThanks = '';
			}, 10000)
		},
		autofill() {
			Object.values(this.categories).map((categoryEntries) => {
				categoryEntries.map((entry) => {
					entry.artistic_merit = Math.floor((Math.random() * 10) / 2) + 1;
					entry.subject_matter = Math.floor((Math.random() * 10) / 2) + 1;
					entry.composition = Math.floor((Math.random() * 10) / 2) + 1;
					entry.originality = Math.floor((Math.random() * 10) / 2) + 1;
					entry.quality = Math.floor((Math.random() * 10) / 2) + 1;
				})
			})
		},
		borderColor(error) {
			return error ? 'red': 'gray';
		},
		forceRefresh() {
			this.refreshKey = this.refreshKey + 1;
		},
	},
	computed: {
		myComputedValue() {
			// just mentioning refreshKey
			return this.refreshKey;
		},
	}
}
</script>
<style>
.hover-show-image:hover > div > img {
	display: block !important;
}
.hover-show-image:hover > img {
	display: block !important;
}
.current {
    background: #e8e8e8;
}
</style>